import React from 'react';
import { path, pathOr } from 'ramda';
import PropTypes from 'prop-types';

import ArrowRight from 'assets/svg-icons/ArrowRight';
import { REPORT_STATUSES, RECEIVER_TYPE, PUBLIC_ID, META, CREATED, STATUS } from 'store/reports';
import { parseDate } from 'utils';

import { NAMES } from './consts';
import { Container, NavLink, ContentContainer, LeftSide, RightSide, Bold, Status } from './styles';

const Panel = ({ report }) => {
  const { [RECEIVER_TYPE]: type, [META]: meta, [PUBLIC_ID]: id, [STATUS]: status } = report;

  return (
    <Container>
      <NavLink to="/reports">
        <ArrowRight />
      </NavLink>
      <ContentContainer>
        <LeftSide>{`Bericht ${NAMES[type] || '-'} vom ${parseDate(meta[CREATED])}`}</LeftSide>
        <RightSide>
          <Bold>{id}</Bold>
          <Status $color={path([status, 'color'], REPORT_STATUSES)}>{pathOr('-', [status, 'title'], REPORT_STATUSES)}</Status>
        </RightSide>
      </ContentContainer>
    </Container>
  );
};

Panel.propTypes = {
  report: PropTypes.shape({
    [RECEIVER_TYPE]: PropTypes.string.isRequired,
    [PUBLIC_ID]: PropTypes.string.isRequired,
    [STATUS]: PropTypes.number.isRequired,
  }).isRequired,
};

export default Panel;
